import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderStatus = _resolveComponent("OrderStatus")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, {
    button: true,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/orders/' + _ctx.order.uuid)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['inner'])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.order.display_name), 1),
          (0&&_ctx.path)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.path), 1))
            : _createCommentVNode("", true),
          ( _ctx.order.provider?.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.order.provider?.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['right'])
        }, [
          _createVNode(_component_OrderStatus, { order: _ctx.order }, null, 8, ["order"]),
          (!_ctx.order?.sync_needed)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(_ctx.$style['date'])
              }, _toDisplayString(_ctx.moment(_ctx.order.created_at) > _ctx.moment().subtract(14, 'days') ? _ctx.moment(_ctx.order.created_at).fromNow() : _ctx.moment(_ctx.order.created_at).format('LL')), 3))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['user-pictures'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordered_roles, (role) => {
              return (_openBlock(), _createElementBlock("img", {
                key: role.user.uuid,
                src: role.user.profile_picture,
                loading: "lazy"
              }, null, 8, _hoisted_3))
            }), 128))
          ], 2)
        ], 2)
      ], 2)
    ]),
    _: 1
  }))
}